import React from 'react';

const Welcome = () => {
  return (
    <section className="welcome">
      <div className="container">
        <div className="welcome-content">
          <h2 className="section-title">Welcome to Dr. Deepika Sinha's Aesthetic Clinic</h2>
          <div className="welcome-text">
            <p>
              We are a leading Cosmetic and Reconstructive Surgery center based in Bhopal.
              Dr. Deepika Sinha (MCh, Plastic Surgery & MRCS, Glasgow, UK) brings over 10 years of surgical experience from Delhi and NCR, using US FDA approved state-of-the-art technology and focusing on natural looking, subtle results.
              Our clinic represents excellence and innovation as a leader in the aesthetics industry.
            </p>
            <div className="slogan">
              <h3>We deliver the extraordinary.</h3>
            </div>
          </div>
          <div className="contact-info">
            <a href="tel:+91-9654495307" className="contact-btn">
              <i className="fas fa-phone"></i>
              +91-9654495307
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;